<div class="flex flex-wrap gap-4 mb-8 items-center">
  <app-select-single
    label="Voting Right"
    [options]="votingRightOptions"
    id="srsVotingRight"
    class="w-full sm:w-1/2 lg:w-1/4"
    (valueChange)="onFilterChange($event, true)"
  ></app-select-single>

  <app-select-single
    *ngIf="isShowingLocations"
    label="locations"
    [options]="locationOptions"
    id="srsVoteLocation"
    class="w-full sm:w-1/2 lg:w-1/4"
    (valueChange)="onFilterChange($event, false)"
  ></app-select-single>

  <!-- Button aligned to the right -->
  <div 
    class="ml-auto"
    *ngIf="isUserPmOrAbove && ballotInOpenOrDecisionPendingStatus">
    <button
      id="SRS-Proxy-Vote"
      class="btn body-default-regular btn-primary"
      type="button"
      [disabled]="selectedVoteCount < 2"
      (click)="openProxyVoteModal()"
    >
      Proxy vote
      <span *ngIf="selectedVoteCount >= 2">({{ selectedVoteCount }})</span>
    </button>
  </div>
</div>

<app-table
  class="mt-5"
  [loading]="false"
  [data]="showingVotes"
  [columns]="viewVoteTableColumns"
  [pagination]="false"
  [isDropdownChanged]="isDropdownChanged"
  (onSelectedRowsChanged)="onSelectedRowsChanged($event)"
  id="viewVoteTable"
></app-table>


<div
  *ngIf="showingVotes.length > 0"
  class="flex justify-end py-1 my-4"
  >
    <app-pagination
      [totalRecords]="totalRecords"
      [recordsPerPage]="pageSize"
      [currentPage]="selectedPageNumber"
      (pageChange)="onPageChange($event)"
  ></app-pagination>
</div>
